import React from 'react';
import './Experience.css';
import {BsFillPatchCheckFill} from 'react-icons/bs';

const Experience = () => {
  return (
    <section id='experience'>
      <h5>What I work with</h5>
      <h2>Skills</h2>

      <div className='container experience_container'>
        <div className='experience_frontend'>
          <h3>Security Operations</h3>
          <div className='experience_content'>
            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>Malware Cleanup</h4>
                <small className='text_highlight'>Customer servers</small>
              </div>
            </article>
            
            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>Malware Analysis</h4>
                <small className='text_highlight'>Live infections</small>
              </div>
            </article>

            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>Regex / Detection</h4>
                <small className='text_highlight'>Automated cleaning</small>
              </div>
            </article>

            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>CompTIA Security+</h4>
                <small className='text_highlight'>Certified 2026</small>
              </div>
            </article>
          </div>
        </div>

        <div className='experience_backend'>
          <h3>Automation &amp; Tooling</h3>
          <div className='experience_content'>
            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>Python</h4>
                <small className='text_highlight'>Scripts &amp; tools</small>
              </div>
            </article>
            
            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>Internal Tools</h4>
                <small className='text_highlight'>Team workflows</small>
              </div>
            </article>

            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>PowerShell</h4>
                <small className='text_highlight'>Ops automation</small>
              </div>
            </article>

            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>Git</h4>
                <small className='text_highlight'>Version control</small>
              </div>
            </article>
          </div>
        </div>

        <div className='experience_database'>
          <h3>Systems &amp; Homelab</h3>
          <div className='experience_content'>
            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>Linux</h4>
                <small className='text_highlight'>Home lab</small>
              </div>
            </article>
            
            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>Pi-hole</h4>
                <small className='text_highlight'>DNS filtering</small>
              </div>
            </article>

            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>File Monitoring</h4>
                <small className='text_highlight'>Host visibility</small>
              </div>
            </article>

            <article className='experience_details'>
              <BsFillPatchCheckFill className="experience_details-icon"/>
              <div>
                <h4>Networking</h4>
                <small className='text_highlight'>Self-hosted services</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience
